import { render, staticRenderFns } from "./MovieEdit.vue?vue&type=template&id=56ef26aa&"
import script from "./MovieEdit.vue?vue&type=script&lang=js&"
export * from "./MovieEdit.vue?vue&type=script&lang=js&"
import style0 from "./MovieEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports